import React from 'react';

import {Renderer} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {FilterDropdownBox} from './filterDropdownBox/filterDropdownBox';
import {
  ResourceMultiSelectFilterDropdown,
  ResourceMultiselectFilterDropdownBaseProps,
} from './resourceMultiSelectFilterDropdown';

/*
 * Props.
 */

export interface ResourceMultiSelectFilterProps<T> extends ResourceMultiselectFilterDropdownBaseProps<T> {
  renderButtonValue: Renderer;
  width?: number | string;
}

/*
 * Component.
 */

export const ResourceMultiSelectFilter = <T,>(props: ResourceMultiSelectFilterProps<T>) => {
  const {
    dropdownTitle,
    dropdownSource,
    computeFilterGenerator,
    selectedItemIds: previousSelectedItemIds,
    onSetItems,
    renderButtonValue,
    onClearAll,
    searchPlaceholder,
    shouldAutoApply,
    clearBehavior,
    width,
  } = props;

  const isActive = (previousSelectedItemIds ?? []).length > 0;

  const renderDropdown = (popoverTransferProps: PopoverTransferProps) => (
    <ResourceMultiSelectFilterDropdown
      {...popoverTransferProps}
      dropdownTitle={dropdownTitle}
      dropdownSource={dropdownSource}
      selectedItemIds={previousSelectedItemIds}
      searchPlaceholder={searchPlaceholder}
      computeFilterGenerator={computeFilterGenerator}
      onSetItems={onSetItems}
      onClearAll={onClearAll}
      shouldAutoApply={shouldAutoApply}
      clearBehavior={clearBehavior}
      width={width}
    />
  );

  return (
    <FilterDropdownBox isActive={isActive} renderDropdown={renderDropdown} renderButton={renderButtonValue} />
  );
};
